export default "__VITE_ASSET__gm9ieutO__"